import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { D_INV010, D_INV170, DISPLAY, TOKEN, USER } from "../../constants/localStorage";

interface ButtonsState {
  gridView: boolean;
  listView: boolean;
}

type appState = {
  token: string;
  user: string;
  buttonsState: ButtonsState;
  notificationMessage: any;
  formModified: number;
  showModalProductNotFound: boolean;
  tacheToUpdate: number;
  d_inv010: any;
  d_inv170: any;
};

const initialState: appState = {
  token: localStorage.getItem(TOKEN) ? localStorage.getItem(TOKEN)! : "",
  user: localStorage.getItem(USER) ? localStorage.getItem(USER)! : "",
  buttonsState: localStorage.getItem(DISPLAY) ? JSON.parse(localStorage.getItem(DISPLAY)!) : { gridView: true, listView: false },
  notificationMessage: null,
  formModified: 0,
  showModalProductNotFound: false,
  tacheToUpdate: -1,
  d_inv010: localStorage.getItem(D_INV010) ? JSON.parse(localStorage.getItem(D_INV010)!) : {},
  d_inv170: localStorage.getItem(D_INV170) ? JSON.parse(localStorage.getItem(D_INV170)!) : {},
};

export const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setUser: (state, action: PayloadAction<string>) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.token = "";
      state.user = "";
      localStorage.clear();
    },
    setButtonsState: (state, action: PayloadAction<ButtonsState>) => {
      localStorage.setItem(DISPLAY, JSON.stringify(action.payload));
      state.buttonsState = action.payload
    },
    addNotificationMessage: (state, action) => {
      state.notificationMessage = action.payload;
    },
    removeNotificationMessage: (state) => {
      state.notificationMessage = null;
    },
    setFormModified: (state, action) => {
      state.formModified = action.payload;
    },
    setShowModalProductNotFound: (state, action) => {
      state.showModalProductNotFound = action.payload;
    },
    setTacheToUpdate: (state, action) => {
      state.tacheToUpdate = action.payload;
    },
    setd_inv010: (state, action) => {
      state.d_inv010 = action.payload;
      localStorage.setItem(D_INV010, JSON.stringify(action.payload));
    },
    setd_inv170: (state, action) => {
      state.d_inv170 = action.payload;
      localStorage.setItem(D_INV170, JSON.stringify(action.payload));
    }
  }
});

export const {
  setToken,
  setUser,
  logout,
  setButtonsState,
  addNotificationMessage,
  removeNotificationMessage,
  setFormModified,
  setShowModalProductNotFound,
  setTacheToUpdate,
  setd_inv010,
  setd_inv170
} = appStateSlice.actions;

export default appStateSlice.reducer;